<DetailFormly ref="detailFormly" :fields="fields" :edit="isEditMode" @update="onUpdate" @validate="onValidate"
  @click="onClicked" :model=" model" />